export default "__VITE_ASSET__C$ObOECF__"